export const KEY_CULTURE = `ciq_user_culture`;
